import React, { useState, useEffect } from 'react';
import ReactSVG from 'react-svg';
import { UserIcon, DownloadIcon } from '~/assets/svgIcons';
import { electron, openExternalURL, log } from '~/helpers';
import { Container, ContactInfo, Name, Number } from './styles';

interface ContactPreviewProps {
  name?: string;
  number?: number;
  url: string;
}

const ContactPreview: React.FC<ContactPreviewProps> = ({
  name,
  number,
  url,
}) => {
  const [contactName, setContactName] = useState(name || 'Shared Contact');
  const [contactFirstNumber, setContactFirstNumber] = useState<
    string | number | undefined
  >(number);

  useEffect(() => {
    if (!window.isElectron) return;
    if (!url) return;

    const fetchContactCard = async () => {
      try {
        const res = await fetch(url);
        const vcf = await res.text();
        const contact = vcf
          .split(/\r?\n/)
          .reduce<Record<string, string[]>>((acc, line) => {
            const match = line.match(/^([^:;]+)(?:;[^:]*)?:(.*)$/);
            if (!match) return acc;
            const [, key, value] = match;
            const k = key.toUpperCase();
            return { ...acc, [k]: [...(acc[k] ?? []), value.trim()] };
          }, {});

        if (contact.FN?.[0]) setContactName(contact.FN[0]);
        if (contact.TEL?.[0]) setContactFirstNumber(contact.TEL[0]);
      } catch (err) {
        log.warn('Failed to fetch contact card:', err);
      }
    };

    fetchContactCard();
  }, [url, setContactName, setContactFirstNumber]);

  const handleDownload = async (event: React.MouseEvent) => {
    event.stopPropagation();

    if (window.isElectron) {
      electron.downloadFile({ url, filename: contactName });
      return;
    }

    openExternalURL(url);
  };
  return (
    <Container className="contact-preview">
      <ReactSVG src={UserIcon} className="icon-contact" />

      <ContactInfo>
        <Name title={contactName}>{contactName}</Name>
        {contactFirstNumber && <Number>{contactFirstNumber}</Number>}
      </ContactInfo>

      <ReactSVG
        src={DownloadIcon}
        className="icon-download"
        onClick={handleDownload}
      />
    </Container>
  );
};

ContactPreview.defaultProps = {
  name: undefined,
  number: undefined,
};

export default ContactPreview;
